import { BooLogo } from "@/components/BooLogo";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { useActiveOrgName } from "@/hooks/useActiveOrgName";

// Mobile-only header. Below `md` the sidebar collapses into an offcanvas sheet,
// so on a phone there was no visible way to open the nav AND no indication of
// which org you were looking at (BOO thread: "nothing tells you which org you
// are in"). This bar restores both: a hamburger to open the sidebar and the
// active org name. Hidden at `md`+ where the sidebar (and its org switcher) show.
export function MobileTopBar() {
  const orgName = useActiveOrgName();

  return (
    <header className="flex h-12 shrink-0 items-center gap-2 border-b px-3 md:hidden">
      <SidebarTrigger className="-ml-1" />
      <BooLogo className="size-5 shrink-0" />
      <span className="truncate text-sm font-semibold">
        {orgName ?? "…"}
      </span>
    </header>
  );
}
